import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { debounce } from "@mui/material";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import React, { useEffect, useMemo, useState } from "react";
import { getAllProductPrice } from "../redux/handlers/logic/getAllProductPrice.handler";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { handleOnSelectProductRowDefault } from "utils/HelperProductRowV2";
export default function ProductrowV2(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, dataID = _param.dataID, columnPresets = _param.columnPresets, OverrideHandleOnSelect = _param.OverrideHandleOnSelect, filterDisplay = _param.filterDisplay, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "dataID",
        "columnPresets",
        "OverrideHandleOnSelect",
        "filterDisplay"
    ]);
    var _useSortable = useSortable({
        id: item.rowID
    }), attributes = _useSortable.attributes, listeners = _useSortable.listeners, setNodeRef = _useSortable.setNodeRef, transform = _useSortable.transform, transition = _useSortable.transition;
    var _useState = _sliced_to_array(useState([]), 2), productSearch = _useState[0], setProductSearch = _useState[1];
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.barcode
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#8E8E8F"
                    },
                    children: item.dimProduct ? item.dimProduct.name_th : "-"
                })
            ]
        }, item.id);
    };
    var finalHandleOnSelect = OverrideHandleOnSelect !== null && OverrideHandleOnSelect !== void 0 ? OverrideHandleOnSelect : handleOnSelectProductRowDefault;
    var handleOnSelect = function(item, rowID) {
        finalHandleOnSelect({
            item: item,
            rowID: rowID,
            values: values,
            optionsWarehouse: optionsWarehouse,
            optionsMstVat: optionsMstVat,
            setProductRow: setProductRow
        });
    };
    var handleOnClear = function() {};
    var handleOnFocus = function() {
        var queryParams = {
            isWithOutDeleted: "true",
            limit: 10,
            searchText: ""
        };
        dispatch(getAllProductPrice({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleOnSearch = function(searchText) {
        debouncedSearch(searchText.trim());
    };
    var getAllProductPriceReducer = useAppSelector(function(state) {
        return state.getAllProductPriceReducer;
    });
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText) {
            var queryParams = _object_spread({
                isWithOutDeleted: "true",
                limit: 10,
                searchText: searchText
            }, values.dim_supplier_information_id && {
                supInfoID: values.dim_supplier_information_id
            });
            dispatch(getAllProductPrice({
                queryParams: queryParams,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }, 300);
    }, [
        productSearch
    ]);
    useEffect(function() {
        if (getAllProductPriceReducer.data && getAllProductPriceReducer.data.data.length > 0) {
            setProductSearch(getAllProductPriceReducer.data.data);
        }
    }, [
        getAllProductPriceReducer
    ]);
    var _useState1 = _sliced_to_array(useState(null), 2), anchorEl = _useState1[0], setAnchorEl = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), popid = _useState2[0], setPopid = _useState2[1];
    var productStandardShareProp = {
        item: item,
        index: index,
        setProductRow: setProductRow,
        columdisplay: columdisplay,
        customSort: customSort,
        rowCount: rowCount,
        addProductRow: addProductRow,
        values: values,
        optionsWarehouse: optionsWarehouse,
        optionsMstDiscountType: optionsMstDiscountType,
        optionsMstVat: optionsMstVat,
        dataID: dataID,
        attributes: attributes,
        listeners: listeners,
        setNodeRef: setNodeRef,
        transform: transform,
        transition: transition,
        productSearch: productSearch,
        setProductSearch: setProductSearch,
        dispatch: dispatch,
        modalObj: modalObj,
        setModalObj: setModalObj,
        handleOnSelect: handleOnSelect,
        handleOnClear: handleOnClear,
        handleOnFocus: handleOnFocus,
        handleOnSearch: handleOnSearch,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        popid: popid,
        setPopid: setPopid,
        formatResult: formatResult,
        filterDisplay: filterDisplay
    };
    return /*#__PURE__*/ _jsx("tr", {
        className: "",
        children: columnPresets.map(function(col, idx) {
            var _filterDisplay_onlyReceiveProduct;
            if ((filterDisplay === null || filterDisplay === void 0 ? void 0 : (_filterDisplay_onlyReceiveProduct = filterDisplay.onlyReceiveProduct) === null || _filterDisplay_onlyReceiveProduct === void 0 ? void 0 : _filterDisplay_onlyReceiveProduct.isActive) && Number(item.productQty) <= 0) {
                return null;
            }
            return /*#__PURE__*/ _jsx(React.Fragment, {
                children: col.render(productStandardShareProp)
            }, col.key || idx);
        })
    });
}
